import _objectSpread from '@babel/runtime/helpers/objectSpread2';
const includes = (array, value) => array.indexOf(value) !== -1;
var includes$1 = includes;
const CURRENCY_ARS = 'ARS';
const CURRENCY_BOB = 'BOB';
const CURRENCY_BRL = 'BRL';
const CURRENCY_CLF = 'CLF';
const CURRENCY_CLP = 'CLP';
const CURRENCY_COP = 'COP';
const CURRENCY_CRC = 'CRC';
const CURRENCY_CUC = 'CUC';
const CURRENCY_CUP = 'CUP';
const CURRENCY_DOP = 'DOP';
const CURRENCY_EUR = 'EUR';
const CURRENCY_GTQ = 'GTQ';
const CURRENCY_HNL = 'HNL';
const CURRENCY_MXN = 'MXN';
const CURRENCY_NIO = 'NIO';
const CURRENCY_PAB = 'PAB';
const CURRENCY_PEN = 'PEN';
const CURRENCY_PYG = 'PYG';
const CURRENCY_USD = 'USD';
const CURRENCY_UYU = 'UYU';
const CURRENCY_VEF = 'VEF';
const CURRENCY_VES = 'VES';
const CURRENCY_DCE = 'DCE';
const CURRENCY_BTC = 'BTC';
const CURRENCY_ETH = 'ETH';
const CURRENCY_USDP = 'USDP';
const CURRENCY_MCN = 'MCN';
const DEFAULT_DECIMALS_AMOUNT = 2;
const CRYPTO_CURRENCY_IDS = {
  CURRENCY_BTC,
  CURRENCY_ETH,
  CURRENCY_USDP,
  CURRENCY_MCN
};
const DEFAULT_CURRENCY_IDS = {
  CURRENCY_ARS,
  CURRENCY_BOB,
  CURRENCY_BRL,
  CURRENCY_CLF,
  CURRENCY_CLP,
  CURRENCY_COP,
  CURRENCY_CRC,
  CURRENCY_CUC,
  CURRENCY_CUP,
  CURRENCY_DOP,
  CURRENCY_EUR,
  CURRENCY_GTQ,
  CURRENCY_HNL,
  CURRENCY_MXN,
  CURRENCY_NIO,
  CURRENCY_PAB,
  CURRENCY_PEN,
  CURRENCY_PYG,
  CURRENCY_USD,
  CURRENCY_UYU,
  CURRENCY_VEF,
  CURRENCY_VES,
  CURRENCY_DCE
};
const AVAILABLE_CURRENCIES = _objectSpread(_objectSpread({}, DEFAULT_CURRENCY_IDS), CRYPTO_CURRENCY_IDS);
const DECIMALS_BY_CURRENCY_ID = {
  [CURRENCY_ARS]: 2,
  [CURRENCY_BOB]: 2,
  [CURRENCY_BRL]: 2,
  [CURRENCY_CLF]: 0,
  [CURRENCY_CLP]: 0,
  [CURRENCY_COP]: 0,
  [CURRENCY_CRC]: 2,
  [CURRENCY_CUC]: 2,
  [CURRENCY_CUP]: 2,
  [CURRENCY_DOP]: 2,
  [CURRENCY_EUR]: 2,
  [CURRENCY_GTQ]: 2,
  [CURRENCY_HNL]: 0,
  [CURRENCY_MXN]: 2,
  [CURRENCY_NIO]: 0,
  [CURRENCY_PAB]: 2,
  [CURRENCY_PEN]: 2,
  [CURRENCY_PYG]: 0,
  [CURRENCY_USD]: 2,
  [CURRENCY_UYU]: 2,
  [CURRENCY_VEF]: 2,
  [CURRENCY_VES]: 2,
  [CURRENCY_DCE]: 2,
  [CURRENCY_BTC]: 8,
  [CURRENCY_ETH]: 8,
  [CURRENCY_USDP]: 8,
  [CURRENCY_MCN]: 8
};
const computeMaxDecimals = (maxDecimals, currencyId) => {
  if (typeof maxDecimals !== 'undefined' && maxDecimals >= 0) return maxDecimals;
  if (currencyId && includes$1(Object.values(AVAILABLE_CURRENCIES), currencyId)) {
    return DECIMALS_BY_CURRENCY_ID[currencyId];
  }
  return DEFAULT_DECIMALS_AMOUNT;
};
export { computeMaxDecimals as default };
